import * as React from 'react';
import {StyleProp, ViewStyle} from 'react-native';

interface IProps {
  width?: number;
  style?: StyleProp<ViewStyle>;
}

export default (props: IProps) => {
  const {width: size} = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="17.3433" cy="17.5" rx="17.3433" ry="17.5" fill="#0088FF" />
      <path
        d="M9.14469 12.2117C10.1577 11.7882 11.6104 11.3314 13.0229 11.1895C14.5453 11.0361 15.8365 11.2616 16.5852 12.0503V23.2064C15.5149 22.5997 14.1584 22.5162 12.9073 22.6421C11.5566 22.7795 10.1944 23.1698 9.14469 23.5704V12.2117ZM17.7299 12.0503C18.4785 11.2616 19.7697 11.0361 21.2921 11.1895C22.7047 11.3314 24.1573 11.7882 25.1703 12.2117V23.5704C24.1195 23.1698 22.7585 22.7783 21.4077 22.6432C20.1555 22.5162 18.8001 22.5986 17.7299 23.2064V12.0503ZM17.1575 11.0155C16.03 10.0459 14.3954 9.9017 12.9073 10.0505C11.1742 10.2257 9.42514 10.8197 8.33539 11.3154C8.2354 11.3609 8.15061 11.4342 8.09114 11.5265C8.03167 11.6189 8.00003 11.7264 8 11.8362V24.4278C8.00003 24.5236 8.02408 24.6178 8.06996 24.7019C8.11584 24.7859 8.18208 24.8571 8.2626 24.9089C8.34313 24.9608 8.43538 24.9916 8.53089 24.9985C8.6264 25.0054 8.72212 24.9883 8.8093 24.9486C9.81891 24.4908 11.4455 23.9402 13.0218 23.7811C14.6346 23.6185 15.9865 23.8807 16.7111 24.785C16.7647 24.8518 16.8327 24.9058 16.9099 24.9428C16.9872 24.9799 17.0718 24.9991 17.1575 24.9991C17.2432 24.9991 17.3278 24.9799 17.4051 24.9428C17.4824 24.9058 17.5503 24.8518 17.6039 24.785C18.3285 23.8807 19.6804 23.6185 21.2921 23.7811C22.8695 23.9402 24.4973 24.4908 25.5057 24.9486C25.5929 24.9883 25.6886 25.0054 25.7841 24.9985C25.8797 24.9916 25.9719 24.9608 26.0524 24.9089C26.133 24.8571 26.1992 24.7859 26.2451 24.7019C26.291 24.6178 26.315 24.5236 26.315 24.4278V11.8362C26.315 11.7264 26.2834 11.6189 26.2239 11.5265C26.1644 11.4342 26.0796 11.3609 25.9796 11.3154C24.8899 10.8197 23.1408 10.2257 21.4077 10.0505C19.9197 9.90056 18.285 10.0459 17.1575 11.0155Z"
        fill="white"
      />
    </svg>
  );
};
